import { Button } from '@mui/material'
import { ChangemakerProfile } from './assets/ChangemakerProfile'
import { AnalyzePriorities } from './assets/AnalyzePriorities'
import { ImpactPlan } from './assets/ImpactPlan'
import { IntakeFlowStep } from '../../constants'
import {
  Container,
  IconsContainer,
  IconContainer,
  Description,
  StartButton,
  Label,
} from './Welcome.styled'

type WelcomeProps = {
  onNextStep: (nextStep: IntakeFlowStep) => void
}

export const Welcome = ({ onNextStep }: WelcomeProps) => (
  <Container>
    <IconsContainer>
      <IconContainer>
        <ChangemakerProfile />
        <Label>Changemaker Profile</Label>
      </IconContainer>
      <IconContainer>
        <AnalyzePriorities />
        <Label>Analyze Priorities</Label>
      </IconContainer>
      <IconContainer>
        <ImpactPlan />
        <Label>Impact Plan</Label>
      </IconContainer>
    </IconsContainer>
    <Description>
      Your journey to greater impact starts here. We&apos;ll begin by getting to
      know your nonprofit and understanding your priorities. Then, we&apos;ll
      generate an impact plan tailored to your organization&apos;s unique needs
      and goals. Let&apos;s dive in and make it happen!
    </Description>
    <StartButton
      variant='contained'
      color='primary'
      onClick={() => onNextStep(IntakeFlowStep.WHAT_YOU_DO)}
    >
      Get Started
    </StartButton>
  </Container>
)
